import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom"; // Ensure this is imported
import "./Login.css"; // Import the CSS file
import { login } from "../api/api"; // Import the login function
import { Link } from "react-router-dom";

const Login: React.FC<{ setIsAuthenticated: (isAuthenticated: boolean) => void; setToken: (token: string) => void }> = ({ setIsAuthenticated, setToken }) => {
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [errorMessage, setErrorMessage] = useState(""); // State for error message
    const navigate = useNavigate(); // Initialize useNavigate

    useEffect(() => {
        const session = localStorage.getItem("session");
        if (session) {
            const { expiry } = JSON.parse(session);
            if (expiry > Date.now()) {
                navigate("/dashboard"); // Redirect to dashboard if already logged in
            }
        }
    }, [navigate]);

    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault();
        try {
            const response = await login(email, password);
            if (response.message === "Login successful") {
                // Set authentication state
                setIsAuthenticated(true);

                // Store session
                const expiry = Date.now() + 120 * 1000; // 2 minutes
                localStorage.setItem("session", JSON.stringify({ expiry }));

                // Navigate to dashboard
                navigate("/dashboard");
            } else {
                setErrorMessage("Login failed. Please check your credentials.");
            }
        } catch (error) {
            setErrorMessage("Login failed. Please check your credentials.");
        }
    };

    return (
        <div className="login-container">
            <h1>Welcome</h1>
            <form onSubmit={handleSubmit} className="login-form">
                <input type="email" value={email} onChange={e => setEmail(e.target.value)} required placeholder="Username or email address*" />
                <input type="password" value={password} onChange={e => setPassword(e.target.value)} required placeholder="Password" />
                {errorMessage && <p className="error-message">{errorMessage}</p>} {/* Render error message */}
                <p className="forgot-password">
                    <Link to="/forgot-password">Forgot Password?</Link>
                </p>
                <button type="submit">Sign In</button>
                <div className="or-divider">
                    <span>OR</span>
                </div>
                <div className="google-button">Continue with Google</div>
                <p>
                    Don't have an account? <Link to="/signup">Sign up and get started</Link>
                </p>
            </form>
        </div>
    );
};

export default Login;
